module.exports = __webpack_public_path__ + "static/img/cardbg1.e1cda5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardbg1.png
// module id = 3J6T
// module chunks = 1